import { render, staticRenderFns } from "./NavbarServices.vue?vue&type=template&id=a22708ea&scoped=true"
import script from "./NavbarServices.vue?vue&type=script&lang=js"
export * from "./NavbarServices.vue?vue&type=script&lang=js"
import style0 from "./NavbarServices.vue?vue&type=style&index=0&id=a22708ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22708ea",
  null
  
)

export default component.exports